import { defineMessages } from 'react-intl';

const messages = defineMessages({
  taskSummary: {
    id: 'App.Home.TaskTab.TaskSummary',
    defaultMessage: 'Task Summary',
  },
  legendRed: {
    id: 'App.Home.TaskTab.LegendRed',
    defaultMessage: 'Past Due',
  },
  legendYellow: {
    id: 'App.Home.TaskTab.LegendYellow',
    defaultMessage: 'Unassigned or Assignee no longer has access',
  },
  portalUser: {
    id: 'App.Home.TaskTab.PortalUser',
    defaultMessage: 'Portal',
  },
  residentActivity: {
    id: 'App.Home.TaskTab.ResidentActivity',
    defaultMessage: 'Resident Activity',
  },
  applicantActivity: {
    id: 'App.Home.TaskTab.ApplicantActivity',
    defaultMessage: 'Applicant Activity',
  },
  workOrders: {
    id: 'App.Home.TaskTab.WorkOrders',
    defaultMessage: 'Work Orders',
  },
  renewalsInProcessTitle: {
    id: 'App.Home.TaskTab.RenewalsInProcess.Title',
    defaultMessage: 'Renewals In Process',
  },
  transfersInProcessTitle: {
    id: 'App.Home.TaskTab.TransfersInProcess.Title',
    defaultMessage: 'Transfers In Process',
  },
  scheduledMoveOutTitle: {
    id: 'App.Home.TaskTab.ScheduledMoveOut.Title',
    defaultMessage: 'Scheduled Move-Outs',
  },
  pendingFASTitle: {
    id: 'App.Home.TaskTab.PendingFAS.Title',
    defaultMessage: 'Prior Resident Final Account Statements Not Generated',
  },
  openWorkOrdersTitle: {
    id: 'App.Home.TaskTab.openWorkOrders.Title',
    defaultMessage: 'Open Work Orders',
  },
  scheduledMoveInsTitle: {
    id: 'App.Home.TaskTab.scheduledMoveIns.Title',
    defaultMessage: 'Approved Applications - Scheduled Move-Ins',
  },
  applicationsInProcessTitle: {
    id: 'App.Home.TaskTab.applicationsInProcess.Title',
    defaultMessage: 'Applications - In Process and New Portal App',
  },
  unitHeader: {
    id: 'App.Home.TaskTab.RenewalsInProcess.UnitHeader',
    defaultMessage: 'Unit',
  },
  numberOfBedroomsHeader: {
    id: 'App.Home.TaskTab.RenewalsInProcess.NumberOfBedroomsHeader',
    defaultMessage: '# of Bedrooms',
  },
  residentHeader: {
    id: 'App.Home.TaskTab.RenewalsInProcess.ResidentHeader',
    defaultMessage: 'Resident',
  },
  leaseExpirationHeader: {
    id: 'App.Home.TaskTab.RenewalsInProcess.ExpirationHeader',
    defaultMessage: 'Lease Expiration',
  },
  assignedToHeader: {
    id: 'App.Home.TaskTab.RenewalsInProcess.AssignedToHeader',
    defaultMessage: 'Assigned To',
  },
  scheduledMoveOutDate: {
    id: 'App.Home.TaskTab.ScheduledMoveOut.AssignedToHeader',
    defaultMessage: 'Scheduled Move-Out Date',
  },
  priorResidentHeader: {
    id: 'App.Home.TaskTab.PendingFAS.priorResidentHeader',
    defaultMessage: 'Prior Resident',
  },
  moveOutDateHeader: {
    id: 'App.Home.TaskTab.PendingFAS.moveOutDateHeader',
    defaultMessage: 'Move-Out Date',
  },
  dueDateHeader: {
    id: 'App.Home.TaskTab.PendingFAS.dueDateHeader',
    defaultMessage: 'Due Date',
  },
  issueHeader: {
    id: 'App.Home.TaskTab.openWorkOrders.issue',
    defaultMessage: 'Issue',
  },
  priorityHeader: {
    id: 'App.Home.TaskTab.openWorkOrders.priorityHeader',
    defaultMessage: 'Priority',
  },
  daysOpenHeader: {
    id: 'App.Home.TaskTab.openWorkOrders.daysOpenHeader',
    defaultMessage: 'Days Open',
  },
  applicantHeader: {
    id: 'App.Home.TaskTab.scheduledMoveIns.applicantHeader',
    defaultMessage: 'Applicant',
  },
  scheduledMoveInDateHeader: {
    id: 'App.Home.TaskTab.scheduledMoveIns.scheduledMoveInDateHeader',
    defaultMessage: 'Scheduled Move-In Date',
  },
  scheduledTransferDateHeader: {
    id: 'App.Home.TaskTab.scheduledTransfers.scheduledTransferDateHeader',
    defaultMessage: 'Scheduled Transfer Date',
  },
  desiredMoveInDateHeader: {
    id: 'App.Home.TaskTab.desiredMoveIns.desiredMoveInDateHeader',
    defaultMessage: 'Desired Move-In Date',
  },
  leasesTitle: {
    id: 'App.Home.TaskTab.Leases.LeasesTitle',
    defaultMessage: 'Leases',
  },
  leasesTeamMemberHeader: {
    id: 'App.Home.TaskTab.Leases.LeasesTeamMemberHeader',
    defaultMessage: 'Team Member',
  },
  leasesGeneratedHeader: {
    id: 'App.Home.TaskTab.Leases.LeasesGeneratedHeader',
    defaultMessage: 'Generated',
  },
  leasesApprovedHeader: {
    id: 'App.Home.TaskTab.Leases.LeasesApprovedHeader',
    defaultMessage: 'Approved',
  },
  leasesDeniedAndCanceledHeader: {
    id: 'App.Home.TaskTab.Leases.LeasesDeniedAndCanceledHeader',
    defaultMessage: 'Denied / Canceled',
  },
  leasesTotalRowLabel: {
    id: 'App.Home.TaskTab.Leases.LeasesTotalRowLabel',
    defaultMessage: 'Team',
  },
  monthToMonthDateOption: {
    id: 'App.Home.TaskTab.Leases.MonthToDateOption',
    defaultMessage: 'Month to Date',
  },
  prospectsFollowUpTitle: {
    id: 'App.Home.TaskTab.ProspectsFollowUp.sectionHeader',
    defaultMessage: 'Prospects - Follow Up',
  },
  daysSinceContactHeader: {
    id: 'App.Home.TaskTab.ProspectsFollowUp.daysSinceHeader',
    defaultMessage: 'Days Since Contact',
  },
  numOfActivitiesHeader: {
    id: 'App.Home.TaskTab.ProspectsFollowUp.numActivitiesHeader',
    defaultMessage: '# of Activities',
  },
  prospectNameHeader: {
    id: 'App.Home.TaskTab.ProspectsFollowUp.prospectNameHeader',
    defaultMessage: 'Name',
  },
  legendGreen: {
    id: 'App.Home.TaskTab.LegendGreen',
    defaultMessage: 'Lease is Ready to be Executed',
  },
});

export default messages;
